export default {
  apiUrl: process.env.REACT_APP_API_URL,
  stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  healthToken: process.env.REACT_APP_HEALTH_TOKEN,
  adminHolder: process.env.REACT_APP_ADMIN_HOLDER
};
